import { ILoginUser } from "../../shared/interfaces/user/IUser";
import { requests } from "../../utils/api/api.service";
import { BASE_URL, LOGIN_URL, ME_URL } from "../../utils/api/endpoints";

export const AuthService = {
  login: (payload: ILoginUser) => requests.post(LOGIN_URL, payload),
  enums: () => requests.get(BASE_URL + "/enums"),
  me: (token: string) => requests.get(`${ME_URL}?token=${token}`),
};
